ACC.unitSelection = {
  customerSelectionPage: function() {
    $(document).on('click', '.ph-b2bunitselection__continue', function(e) {
      var listOfSalesOrgsArray = [],
          $unitSelectionWrapper = $('.ph-b2bUnitSelection__Wrapper'),
          $listOfSalesOrgs = $unitSelectionWrapper.find('.b2bUnitListOfSalesOrgs'),
          numberOfSelectionBoxes = $('.ph-b2bunitselection__customer--main').length,
          customerSelectedItems = 0;

      $('.ph-b2bunitselection__customer--main').each(function() {
        var customerSelection = '',
            unitSalesOrg = $(this).find('.ph-b2bUnitSalesOrgVal').html(),
            $unitSalesOrgInputId = $('.b2bUnitId' + unitSalesOrg),
            $unitSelectionInput = $(this).find('.ph-b2bunitselection__input');

        listOfSalesOrgsArray.push(unitSalesOrg);

        $unitSelectionInput.each(function() {
          if ($(this).is(':checked')) {
            customerSelection = $(this).val();
          }
        });

        if (customerSelection) {
          customerSelectedItems = customerSelectedItems + 1;
          $unitSalesOrgInputId.val(customerSelection);
        } else {
          e.preventDefault();
        }
      });

      $listOfSalesOrgs.val(listOfSalesOrgsArray);

      if (numberOfSelectionBoxes === customerSelectedItems) {
        $('.ph-customerselection').addClass('ph-disabledbutton ');
        $('.ph-currencyValue').val($('.ph-os-currency').children('option:selected').val());
        $('#b2b_Customer_Selection_Unit_Form').submit();
      }
    });
  },

  homepageUnitSelectionFormSubmit: function(salesOrgVal, unitSelectionValue, unitSelectionFormId) {
    var $unitSelectionForm = $(unitSelectionFormId);

    $unitSelectionForm.find('.b2bUnitListOfSalesOrgs').val(salesOrgVal);
    $unitSelectionForm.find('.b2bUnit' + salesOrgVal).val(unitSelectionValue);
    sessionStorage.setItem('b2bCartReminder', 'initiated');
    $unitSelectionForm.submit();
  },

  homePageUnitSelection: function() {
    $(document).on('change', '.ph-homepage__b2bUnitDesktop--select', function() {
      var desktopSalesOrgVal = $(this).parent('.ph-homepage__b2bUnitDesktop--selectionMain').find('.ph-homepage__b2bUnitDesktop--salesOrg').html(),
          desktopUnitSelectionValue = $(this).val();

      ACC.unitSelection.homepageUnitSelectionFormSubmit(desktopSalesOrgVal, desktopUnitSelectionValue, '#desk_b2b_Customer_Selection_Unit_Form');
    });

    $(document).on('change', '.ph-homepage__b2bUnitMobile--select', function() {
      var mobileSalesOrgVal = $(this).parent('.ph-homepage__b2bUnitMobile--selectionMain').find('.ph-homepage__b2bUnitMobile--salesOrg').html(),
          mobileUnitSelectionValue = $(this).val();

      ACC.unitSelection.homepageUnitSelectionFormSubmit(mobileSalesOrgVal, mobileUnitSelectionValue, '#mob_b2b_Customer_Selection_Unit_Form');
    });
  },
  enableDisableContinueCondition: function() {
    if ($('.ph-b2bunitselection__input:checked').length === $('.ph-b2bunitselection__customer--main').length) {
      $('.ph-b2bunitselection__continue').removeClass('disabled');
    }
  },
  enableDisableContinuebutton: function() {
    $(document).on('click', '.ph-b2bunitselection__input', function() {
      ACC.unitSelection.enableDisableContinueCondition();
    });
  },

  b2bPageDropdownsSubmit: function() {
    $(document).on('change', '.ph-select-market select', function() {
      $('#b2b_selectBox_oneStore').submit();
    });
    $(document).on('change', '.ph-b2b_multilang select', function() {
      $('#b2b_multilanguage_form').submit();
    });
  },
  cartReminderOnB2bSelection: function() {
    if (ACC.cartReminder.flagValue === 'true' && sessionStorage.getItem('b2bCartReminder') === 'initiated') {
      ACC.cartReminder.cartReminderShowPopUp();
    }

    sessionStorage.removeItem('b2bCartReminder');
  }
};

$(document).ready(function() {
  ACC.unitSelection.customerSelectionPage();
  ACC.unitSelection.homePageUnitSelection();
  ACC.unitSelection.cartReminderOnB2bSelection();
  ACC.unitSelection.enableDisableContinuebutton();
  ACC.unitSelection.b2bPageDropdownsSubmit();
  ACC.unitSelection.enableDisableContinueCondition();
});
